import React from "react";
import SetMessageComponent from "./SetMessageComponent";

function SetEmailMessage() {
  return (
    <SetMessageComponent
      messageType="email"
      title="Set Email Confirmation Message"
      description={`Enter the email confirmation message template below. Here are the available tags to use: <name> the person's first name, <datestr> the date, <timestr> the time, and <link> the reschedule link.`}
    />
  );
}

export default SetEmailMessage;